import { Package } from "lucide-react";

export const fmtWords = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k words` : `${n || 0} words`);
const num = (n) => (n == null ? "" : Number.isInteger(Number(n)) ? Number(n) : n);

function Node({ b, i, cover, href, Wrap, current }) {
  return (
    <li className="relative shrink-0 w-32 sm:w-36 fade-up" style={{ animationDelay: `${i * 0.07}s` }} data-testid={`timeline-book-${b.slug || b.id}`}>
      <span className={`absolute left-1/2 -translate-x-1/2 top-[7px] w-3.5 h-3.5 rounded-full border-2 ${current ? "bg-amber-300 border-amber-200 shadow-[0_0_14px_rgba(199,125,255,0.9)]" : "bg-slate-950 border-amber-400"}`} />
      <p className="text-center text-[10px] font-display tracking-[0.25em] text-amber-300 pt-7">{b.book_number != null ? `BOOK ${num(b.book_number)}` : "—"}</p>
      <Wrap to={href} className="block mt-3 group">
        <div className={`aspect-[2/3] rounded-md overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.55)] group-hover:shadow-[0_0_28px_rgba(157,78,221,0.5)] transition-shadow ${current ? "ring-2 ring-amber-400" : ""}`}>{cover(b)}</div>
        <p className="text-sm leading-tight mt-2 group-hover:text-amber-200 transition-colors [overflow-wrap:anywhere]">{b.title}</p>
      </Wrap>
      <p className="text-[11px] text-slate-500 mt-1 font-mono" data-testid={`timeline-words-${b.slug || b.id}`}>{fmtWords(b.word_count)}</p>
    </li>
  );
}

export function Timeline({ data, cover, linkFor, Wrap, currentId, testId = "series-timeline" }) {
  return (
    <div data-testid={testId}>
      <div className="relative overflow-x-auto scrollbar-thin pb-3">
        <div className="absolute left-0 right-0 top-[14px] h-px bg-gradient-to-r from-amber-500/0 via-amber-500/60 to-amber-500/0 min-w-full" />
        <ol className="relative flex gap-5 sm:gap-7 min-w-max px-1">
          {data.books.map((b, i) => <Node key={b.slug || b.id} b={b} i={i} cover={cover} href={linkFor(b)} Wrap={Wrap} current={currentId && (b.slug || b.id) === currentId} />)}
        </ol>
      </div>
      <p className="text-[11px] text-slate-500 mt-1" data-testid={`${testId}-total`}>{data.books.length} book{data.books.length === 1 ? "" : "s"} · {fmtWords(data.total_words)} in reading order</p>
      {data.box_sets?.length > 0 && (
        <div className="mt-5 flex flex-wrap gap-4" data-testid={`${testId}-boxsets`}>
          {data.box_sets.map((x) => (
            <Wrap key={x.slug || x.id} to={linkFor(x)} className="flex items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-950/20 p-2 pr-4 hover:border-amber-400 transition-colors" data-testid={`timeline-boxset-${x.slug || x.id}`}>
              <div className="w-11 aspect-[2/3] rounded overflow-hidden shrink-0">{cover(x, true)}</div>
              <div><p className="text-[10px] tracking-[0.2em] text-amber-300 flex items-center gap-1"><Package size={11} />BOX SET</p><p className="text-sm leading-tight">{x.title}</p>
                <p className="text-[11px] text-slate-500 font-mono">Books {x.contains.map(num).join(", ")} · {fmtWords(x.word_count)}</p></div>
            </Wrap>
          ))}
        </div>
      )}
    </div>
  );
}
